import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "samples"
    }}>{`Samples`}</h1>
    <h2 {...{
      "id": "创建一个新层"
    }}>{`创建一个新层`}</h2>
    <p>{`你可以创建一个脚本，在Photoshop DOM API的帮助下，创建一个新的图层。`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const app = require('photoshop').app;
await app.documents.add();
await app.activeDocument.createLayer();
app.activeDocument.layers[0].name = 'New layer';
`}</code></pre>
    <h2 {...{
      "id": "访问本地文件系统"
    }}>{`访问本地文件系统`}</h2>
    <p>{`你可以在UXP存储模块的帮助下，创建一个访问你的本地文件系统的脚本。`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const uxpfs = require("uxp").storage;
const ufs = uxpfs.localFileSystem;

try {
    const folder = await ufs.getTemporaryFolder()
    const metadata = await folder.getMetadata();
    console.log(JSON.stringify(metadata));
} catch (e) {
    console.log(\`Local File system error: \${e}\`);
}
`}</code></pre>
    <h2 {...{
      "id": "使用文件选取器"
    }}>{`使用文件选取器`}</h2>
    <p>{`你可以创建一个脚本，实例化一个文件选择器，用于写入/保存到文件。`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const fs = require('uxp').storage.localFileSystem;
try {
    // 使用文件选择器将文件保存到一个位置
    const file = await fs.getFileForSaving("demo.txt");
    await file.write("Hello World! This is demo.");
} catch (e) {
    console.log(e);
}
`}</code></pre>
    <h2 {...{
      "id": "readwrite-to-clipboard"
    }}>{`Read/write to clipboard`}</h2>
    <p>{`你可以访问剪贴板模块 (`}<inlineCode parentName="p">{`navigator.clipboard`}</inlineCode>{`) 至: `}</p>
    <ul>
      <li parentName="ul">{`写到剪贴板上 (`}<inlineCode parentName="li">{`setContent()`}</inlineCode>{`)`}</li>
      <li parentName="ul">{`读取剪贴板的内容 (`}<inlineCode parentName="li">{`readText()`}</inlineCode>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`try {
    const clipboard = navigator.clipboard;
    await clipboard.setContent({ 'text/plain': "Test string" });
} catch (e) {
    throw new Error(e);
}
try {
    const clipboard = navigator.clipboard;
    const text = await clipboard.readText();
    console.log(text);
}  catch (e) {
    throw new Error(e);
}
`}</code></pre>
    <h2 {...{
      "id": "创建对话式ui"
    }}>{`创建对话式UI`}</h2>
    <h3 {...{
      "id": "简单的例子"
    }}>{`简单的例子`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`async function createDialog() {
    const dialog = document.createElement("dialog");
    dialog.style.color = "white";
    const div = document.createElement("div");
    div.style.display = "block";
    div.style.height = "200px";
    div.style.width = "400px";
    const header = document.createElement("h2");
    header.id = "head";
    header.style.color = "white";
    header.textContent = "Sample Dialog";
    div.appendChild(header);
    dialog.appendChild(div);
    await document.body.appendChild(dialog).showModal();
}
// 等待对话框的渲染
await createDialog();
`}</code></pre>
    <h3 {...{
      "id": "有-完成-按钮的例子"
    }}>{`有 "完成 "按钮的例子`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`async function showDialog() {
    let dialog = createDialog();
    document.body.appendChild(dialog).showModal();

    // Give the script time to show the dialog by returning a promise. Make sure that it is resolved/rejected later.
    return new Promise((resolve, reject) => {
        try {
            // Resolve the promise and dismiss the dialog when when user clicks on 'Done' button
            const doneBtn = document.getElementById("完成");
            doneBtn.addEventListener("click", () => {
                console.log("user is done");
                dialog.close();
                resolve("user is done");
            })

            // reject when dialog is cancelled/closed
            dialog.addEventListener("cancel", () => {
                console.log("dialog cancelled");
                reject("dialog cancelled");
            });

            dialog.addEventListener("close", () => {
                console.log("dialog closed");
                reject("dialog closed");
            });
        } catch (e) {
            console.log(e);
            reject(e);
        }
    })
}

function createDialog() {
    const dialog = document.createElement("dialog");
    dialog.style.color = "white";
    const div = document.createElement("div");
    div.style.display = "block";
    div.style.height = "200px";
    div.style.width = "400px";
    const header = document.createElement("h2");
    header.id = "head";
    header.style.color = "white";
    header.textContent = "Sample Dialog";
    div.appendChild(header);
    const doneButton = document.createElement("button");
    doneButton.id = "done";
    doneButton.textContent = "Done";
    div.appendChild(doneButton);
    dialog.appendChild(div);
    return dialog;
}

// 等待对话框的渲染
await showDialog();
`}</code></pre>
    <h2 {...{
      "id": "访问已安装的字体"
    }}>{`访问已安装的字体`}</h2>
    <p>{`Photoshop 已将字体模块的权限设置为 `}<inlineCode parentName="p">{`ReadInstalled`}</inlineCode>{`.。这意味着，如果没有指定字体或没有安装字体，那么 UXP 将退回到 "system-ui "字体（默认的操作系统系统 UI 字体）。`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`async function createDialog() {
    const dialog = document.createElement("dialog");

    dialog.style.color = "white";

    const div = document.createElement("div");
    div.style.display = "block";
    div.style.height = "200px";
    div.style.width = "450px";

    const p1 = createParagraph("system-ui"); // use default OS font
    const p2 = createParagraph("non-existent-font"); // try using a non existent font. Will resolve to OS default.
    const p3 = createParagraph("Courier New"); // use any installed font
    div.appendChild(p1);
    div.appendChild(p2);
    div.appendChild(p3);

    dialog.appendChild(div);
    await document.body.appendChild(dialog).showModal();
}

function createParagraph(fontFamily) {
    const p = document.createElement("p");
    p.style.color = "white";
    p.style.fontFamily = fontFamily;
    p.textContent = \`font-family:\${fontFamily}: 狐狸跳过懒惰的狗\`;
    return p;
}

// Wait for the dialog to render
await createDialog();
`}</code></pre>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1034px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "57.8125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uxp-photoshop-zh-cn/static/6e7995d04a092809fd7b8fb8691cf294/5530d/fonts.webp 320w", "/uxp-photoshop-zh-cn/static/6e7995d04a092809fd7b8fb8691cf294/0c8fb/fonts.webp 640w", "/uxp-photoshop-zh-cn/static/6e7995d04a092809fd7b8fb8691cf294/e4622/fonts.webp 1034w"],
            "sizes": "(max-width: 1034px) 100vw, 1034px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uxp-photoshop-zh-cn/static/6e7995d04a092809fd7b8fb8691cf294/dd4a7/fonts.png 320w", "/uxp-photoshop-zh-cn/static/6e7995d04a092809fd7b8fb8691cf294/0f09e/fonts.png 640w", "/uxp-photoshop-zh-cn/static/6e7995d04a092809fd7b8fb8691cf294/b69f7/fonts.png 1034w"],
            "sizes": "(max-width: 1034px) 100vw, 1034px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uxp-photoshop-zh-cn/static/6e7995d04a092809fd7b8fb8691cf294/b69f7/fonts.png",
            "alt": "Fonts example",
            "title": "Fonts example",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      